import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { dispatch } from '../store';

const initialState = {
    isTripTypesLoading: false,
    isFleetsLoading: false,
    isDriversLoading: false,
    isCustomersLoading: false,
    isCustomerAddressesLoading: false,
    isSurchargeGroupLoading: false,
    isSurchargeLoading: false,
    error: null,
    tripTypes: null,
    fleets: null,
    surcharge: null,
    drivers: null,
    customers: null,
    customerAddresses: null,
    isItemTypesLoading: false,
    itemTypes: null,
    surchargeGroups: null,
    isWasteTypesLoading: false,
    wasteTypes: null,
    isDumpstersLoading: false,
    dumpsters: null,
    isTicketsLoading: false,
    tickets: null,
};

const slice = createSlice({
    name: 'ticket',
    initialState,
    reducers: {
        // START LOADING
        startTripTypesLoading(state) {
            state.isTripTypesLoading = true;
        },
        startCustomerLoading(state) {
            state.isCustomersLoading = true;
        },
        startCustomerAddressesLoading(state) {
            state.isCustomerAddressesLoading = true;
        },
        // HAS ERROR
        hasError(state, action) {
            state.isTripTypesLoading = false;
            state.isFleetsLoading = false;
            state.isSurchargeGroupLoading = false;
            state.isDriversLoading = false;
            state.isCompanyStatuseLoading = false;
            state.isCustomersLoading = false;
            state.isSurchargeLoading = false;
            state.isCustomerAddressesLoading = false;
            state.error = action.payload;
        },
        setTripTypes(state, action) {
            state.isTripTypesLoading = false;
            state.tripTypes = action.payload;
        },
        setCustomers(state, action) {
            state.isCustomersLoading = false;
            state.customers = action.payload;
        },
        setCustomerAddresses(state, action) {
            state.isCustomerAddressesLoading = false;
            state.customerAddresses = action.payload;
        },

        startItemTypesLoading(state) {
            state.isItemTypesLoading = true;
        },
        setItemTypes(state, action) {
            state.isItemTypesLoading = false;
            state.itemTypes = action.payload;
        },
        startSurchargeGroupLoading(state) {
            state.isVenderGroupLoading = true;
        },
        startSurchargeLoading(state) {
            state.isSurchargeLoading = true;
        },
        startWasteTypesLoading(state) {
            state.isWasteTypesLoading = true;
        },
        setWasteTypes(state, action) {
            state.isWasteTypesLoading = false;
            state.wasteTypes = action.payload;
        },
        startDumpstersLoading(state) {
            state.isDumpstersLoading = true;
        },
        setDumpsters(state, action) {
            state.isDumpstersLoading = false;
            state.dumpsters = action.payload;
        },
        startTicketsLoading(state) {
            state.isTicketsLoading = true;
        },
        setTickets(state, action) {
            state.isTicketsLoading = false;
            state.tickets = action.payload;
        },
        startTicketIssuesLoading(state) {
            state.isTicketIssuesLoading = true;
        },
        setTicketIssues(state, action) {
            state.isTicketIssuesLoading = false;
            state.ticketIssues = action.payload;
        },
        setSurcharge(state, action) {
            state.isSurchargeGroupLoading = false;
            state.surcharges = action.payload;
        },
        setSurchargeGroups(state, action) {
            state.isSurchargeLoading = false;
            state.surchargeGroups = action.payload;
        },

    },
});

// Reducer
export default slice.reducer;

// Actions
export const {
    startTripTypesLoading,
    startCustomerLoading,
    startSurchargeGroupLoading,
    startSurchargeLoading,
    startCustomerAddressesLoading,
    hasError,
} = slice.actions;

// ----------------------------------------------------------------------

export function getTickets() {
    return async () => {
        dispatch(slice.actions.startTicketsLoading());
        try {
            const response = await axios.get('/admin/ticket/tickets');
            dispatch(slice.actions.setTickets(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getTripTypes() {
    return async () => {
        dispatch(slice.actions.startTripTypesLoading());
        try {
            const response = await axios.get('/admin/ticket/trip_types');
            dispatch(slice.actions.setTripTypes(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getWasteTypes() {
    return async () => {
        dispatch(slice.actions.startTripTypesLoading());
        try {
            const response = await axios.get('/admin/ticket/waste_types');
            dispatch(slice.actions.setWasteTypes(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getEmployeeWasteTypes() {
    return async () => {
        dispatch(slice.actions.startTripTypesLoading());
        try {
            const response = await axios.get('/employee/ticket/waste_types');
            dispatch(slice.actions.setWasteTypes(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getCustomers(companyId = null) {
    return async () => {
        dispatch(slice.actions.startCustomerLoading());
        try {
            const response = await axios.get('/admin/ticket/customers', {
                params: {
                    company_id: companyId
                }
            });
            dispatch(slice.actions.setCustomers(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getCustomerAddresses(id) {
    return async () => {
        dispatch(slice.actions.startCustomerAddressesLoading());
        try {
            const response = await axios.get(`/admin/ticket/customer/address/${id}`);
            dispatch(slice.actions.setCustomerAddresses(response.data.addresses));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getRefAddresses(id, reference) {
    return async () => {
        dispatch(slice.actions.startCustomerAddressesLoading());
        try {
            const response = await axios.get(`/admin/location/get_address/${id}`, {
                params: {
                    reference: reference
                }
            });
            dispatch(slice.actions.setCustomerAddresses(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}


export function getItemTypes(companyId) {
    return async () => {
        dispatch(slice.actions.startItemTypesLoading());
        try {
            const response = await axios.get('/admin/ticket/item_types', {
                params: {
                    company_id: companyId
                }
            });
            dispatch(slice.actions.setItemTypes(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getDumpster() {
    return async () => {
        dispatch(slice.actions.startDumpstersLoading());
        try {
            const response = await axios.get('/admin/ticket/dumpsters');
            dispatch(slice.actions.setDumpsters(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getTicketIssues() {
    return async () => {
        dispatch(slice.actions.startTicketIssuesLoading());
        try {
            const response = await axios.get('/admin/ticket/ticket_issues');
            dispatch(slice.actions.setTicketIssues(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getSurcharge(companyId) {
    return async () => {
        dispatch(slice.actions.startSurchargeLoading());
        try {
            const response = await axios.get(`/admin/ticket/surcharges`, {
                params: {
                    company_id: companyId
                }
            });
            dispatch(slice.actions.setSurcharge(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getSurchargeGroups() {
    return async () => {
        dispatch(slice.actions.startSurchargeGroupLoading());
        try {
            const response = await axios.get(`/admin/ticket/surcharge_groups`);
            dispatch(slice.actions.setSurchargeGroups(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}